import { typeOfPAF } from "../../../../constants/typeOfPAF";

/** At least one capsule row has a value (label or “other”). */
export function isNotSelectedAnyCapsulePerCycle(registerPatient) {
  if (registerPatient?.capsules?.length > 0) {
    return registerPatient.capsules.some(
      (capsule) => Boolean(capsule.label) || Boolean(capsule.other)
    );
  }
  return false;
}

/** WoCP cycle cap check for step validation modals. */
export function checkIfNumberOfCyclesExceeded(registerPatient) {
  if (registerPatient.type !== typeOfPAF.WOMANOFCP) {
    return false;
  }
  const nrCycles = registerPatient?.number_cycles?.id;
  return nrCycles > 1;
}
